import * as React from "react";
import { Checkbox } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/checkbox";

export class WorkersDataTableSelectionRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = { checked: false }
    }
 
    onChange = () => {
        this.setState((prevState) => ({ checked: !prevState.checked }))
    }

    render() {
        const thisAgent = this.props.items?.worker
        const selectAll = document.getElementById("chkAll");
        const isChecked = selectAll?.checked || this.state.checked

        return(<Checkbox 
                    key={thisAgent?.sid + "CHK"} 
                    name="chkStatus" 
                    data-workerid={thisAgent?.sid} 
                    checked={isChecked}
                    onChange={this.onChange}/>)
    }
}
